module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "size": "dessassociate_sequence_roundtable",
      "title": "Remove from Sequence",
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "h-full w-full overflow-y-auto py-4"
  }, [_c('div', {
    staticClass: "flex flex-col h-full"
  }, [_c('div', {
    staticClass: "overflow-y-auto h-full px-5"
  }, [_c('div', [_vm._v("\n          This action will be remove this RoundTable '"), _c('span', {
    staticClass: "font-semibold text-gray-700"
  }, [_vm._v(_vm._s(_vm.roundtable_name))]), _vm._v("' from the sequence. It will not delete the RoundTable, but this action cannot be undone.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col px-5 flex-grow h-full"
  }, [_c('div', {
    staticClass: "flex flex-col w-full space-y-1.5 mb-2"
  }, [_c('span', [_vm._v("Please type in \"confirm\" to continue")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirm_tag_delete),
      expression: "confirm_tag_delete"
    }],
    staticClass: "py-2 px-3 w-full border border-solid border-gray-200 bg-white rounded-md focus-within:border-red-500",
    attrs: {
      "placeholder": "Type 'confirm' to remove roundtable from sequence",
      "type": "text"
    },
    domProps: {
      "value": (_vm.confirm_tag_delete)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleRemoveFromSequence()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirm_tag_delete = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('button', {
    staticClass: "bg-gray-100 py-2 flex items-center justify-center space-x-2 text-blueGray-500 font-medium w-full rounded-md border border-solid border-gray-200",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "bg-red-500 py-2 flex items-center justify-center space-x-2 text-red-50 font-semibold w-full rounded-md border border-solid border-red-500",
    on: {
      "click": function($event) {
        return _vm.handleRemoveFromSequence()
      }
    }
  }, [_c('span', [_vm._v("Confirm")]), _vm._v(" "), (_vm.is_removed_started === true) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e()])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-7449afb5!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/components/RoundTables/Sequences/RoundTableDessassociateModal.vue
// module id = 1290
// module chunks = 61